/**
 * The AppLayoutSidebar class provides functionality for the sidebar in the app layout.
 */
export default class AppLayoutSidebar {
  /**
   * Registers a callback to be invoked when the viewport size changes.
   * @param {any} dotnetHelper - The .NET helper object to invoke methods on.
   */
  registerViewportChangeCallback(dotnetHelper: any) {
    window.addEventListener('load', () => {
      dotnetHelper.invokeMethodAsync('OnResize', window.innerWidth, window.innerHeight);
    });
    window.addEventListener('resize', () => {
      dotnetHelper.invokeMethodAsync('OnResize', window.innerWidth, window.innerHeight);
    });
  }

  /**
   * Registers a callback to be invoked when the sidebar size changes.
   * @param {any} dotnetHelper - The .NET helper object to invoke methods on.
   */
  registerSidebarCallback(dotnetHelper: any) {
    const sb = document.getElementById("sidebar");
    if (sb) {
      this.onresize(sb, () => {
        dotnetHelper.invokeMethodAsync("SidebarResize", sb.offsetWidth, window.innerWidth, window.innerHeight);
      });
    }
  }

  /**
   * Observes the resize event on a DOM element and triggers a callback.
   * @param {Element} domElem - The DOM element to observe.
   * @param {Function} callback - The callback to invoke on resize.
   */
  onresize(domElem: Element, callback: Function) {
    const resizeObserver = new ResizeObserver(() => callback());
    resizeObserver.observe(domElem);
  }
}
